//  @flow
import React from 'react';
import { useTranslation } from 'react-i18next';
//  $Ignore
import { withRouter } from 'react-router-dom';

import Overlay from '../../Components/Overlay';
import Button from '../Button';

import './style.css';

const ExploreCourses = ({
  title = '',
  description = '',
  actionText = '',
  onClick = '',
  history
}) => {
  const { t } = useTranslation();
  const newTitle = title || t('explorecourseHeading');
  const newDescription = description || t('explorecoursePara');
  const newActionText = actionText || t('explorecourseLink');
  const onButtonClick =
    onClick ||
    function click() {
      history.push('/live_classes');
    };
  return (
    <div className="explore-container">
      <Overlay className="explore-overlay ">
        <div className="explore-content">
          <div className="explore-left">
            <span>{newTitle}</span>
            <p>{newDescription}</p>
          </div>

          <div className="explore-right">
            <Button onClick={onButtonClick} text={newActionText} />
          </div>
        </div>
      </Overlay>
    </div>
  );
};
export default withRouter(ExploreCourses);



// WEBPACK FOOTER //
// ./src/Components/ExploreCourse/index.js